if(!customElements.get('pf-refined-cart-gifts'))customElements.define('pf-refined-cart-gifts',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.addEventListener('click',async event=>{
      const button=event.target.closest('[data-cart-gift]');if(!button||this.busy)return;
      this.busy=true;this.querySelectorAll('button').forEach(node=>node.disabled=true);
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const request=crypto.randomUUID();
      try{
        const cartResponse=await fetch(root+'cart.js',{cache:'no-store'});
        if(!cartResponse.ok)throw new Error();
        const cart=await cartResponse.json();
        if(!cart.items.some(item=>item.key===this.dataset.bouquetKey))throw new Error();
        const properties={'Para':this.dataset.bouquet,'_pf_cart_extra':request};
        if(this.dataset.group)properties._pf_cro_group=this.dataset.group;
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.cartGift),quantity:1,properties}]})});
        if(!response.ok)throw new Error();
        location.reload();
      }catch(error){
        this.querySelector('[data-gift-status]').textContent=this.dataset.error;
        try{const check=await fetch(root+'cart.js',{cache:'no-store'});const cart=await check.json();if(cart.items.some(item=>item.properties?._pf_cart_extra===request)){location.reload();return;}}catch(_){return;}
        this.busy=false;this.querySelectorAll('button').forEach(node=>node.disabled=false);
      }
    });
  }
});
